import {POSITION_LATLNG} from './positionTypes'

export const changeposition = position => {
    return {
        type: POSITION_LATLNG,
        load: position
    }
}

export const selectNewPosition = (position) => {

    return (dispatch) => {
        dispatch(changeposition(position))
    }

}